import OnBoardingContainer from '../../../components/on-boarding';
import { Step2 } from '../../../graphql/generated/graphql';
import { fetchOnBoardingStep2 } from '../../../services/on-boarding/onboarding.service';
import { useOnBoarding } from '../hooks/useOnBoarding';
import { useCallback } from 'react';

export default function OnBoardingStep2() {
  const { response, handleNext } = useOnBoarding<Step2>({
    fetchFn: useCallback(fetchOnBoardingStep2, []),
  });

  return (
    <OnBoardingContainer
      image={response.content?.image?.data?.attributes?.url || ''}
      step={1}
      title={response?.content?.title || ''}
      description={response?.content?.description || ''}
      button={{
        text: response?.content?.button?.text || '',
        onClick: () => handleNext(),
      }}
    />
  );
}
